import React from 'react';
import { BettingConfigCtx } from 'root/bettingConfigCtx';

import { BettingWidgets } from 'app-constants';
import { StreamWidgetOptions } from 'types';

const withStreamWidgetSettings = <T extends {}>(
    WrappedComponent: React.ComponentType<T>
): React.ComponentType<T> => {
    return props => (
        <BettingConfigCtx.Consumer>
            {context => {
                const { widgets$ } = context;
                const widgetOptions = widgets$.getValue()[
                    BettingWidgets.STREAM
                ];

                return <WrappedComponent {...props} {...widgetOptions} />;
            }}
        </BettingConfigCtx.Consumer>
    );
};

export type WithStreamWidgetSettingsTypes = StreamWidgetOptions;

export default withStreamWidgetSettings;
